import { Form } from 'formik';
import styled, { css } from 'styled-components/macro';

export const FormWrapper = styled(Form)<{
  margin?: string;
  padding?: string;
  mobilePadding?: string;
  bgColor?: string;
  disabled?: boolean;
  border?: string;
  width?: string;
}>`
  position: relative;

  margin: ${({ margin }) => (margin ? margin : '0')};
  padding: ${({ padding }) => (padding ? padding : '2rem')};
  border: ${({ border, theme }) => (border ? border : `1px solid ${theme.colors.black_20}`)};
  border-radius: 8px;

  ${({ width }) => width && `width: ${width}`};

  background-color: ${({ theme, bgColor }) => (bgColor ? bgColor : theme.colors.white)};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ theme, mobilePadding }) =>
      mobilePadding ? mobilePadding : `${theme.spacing.one_2} ${theme.spacing.zero_2}`};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    border: 0;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      :after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;

        background-color: rgba(255, 255, 255, 0.6);

        content: '';
      }
    `}
`;

export const FormHeading = styled.h2<{ mb?: string; fontSize?: string }>`
  margin-bottom: ${({ theme, mb }) => (mb ? mb : theme.spacing.one_2)};

  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme, fontSize }) => (fontSize ? fontSize : theme.fontSize.lg)};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
`;

export const FormSubheading = styled.span<{ mb?: string }>`
  display: inline-block;
  margin-bottom: ${({ theme, mb }) => (mb ? mb : theme.spacing.one_2)};

  color: ${({ theme }) => theme.colors.black_60};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  line-height: ${({ theme }) => theme.lineHeight.one};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
`;

export const LoginSignupWrapper = styled(FormWrapper)`
  width: 32rem;
  padding: ${({ theme }) => theme.spacing.one_2};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: calc(100% - 1.5rem);
    padding: ${({ theme }) => theme.spacing.one};
  }
`;

export const FormGroup = styled.div<{ width?: string; mb?: string; mt?: string }>`
  position: relative;

  display: flex;
  flex-direction: column;

  width: ${({ width }) => (width ? width : '100%')};
  margin-bottom: ${({ theme, mb }) => (!!mb ? mb : theme.spacing.one_2)};
  ${({ mt }) => mt && `margin-top: ${mt};`}
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    width: 100%;
  }
`;

export const FormCard = styled(FormWrapper)``;
